import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_Dashboard() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  async function getDashboard(affiliate) {
    const queryParams = { affiliate };

    const { headers, queryString } = await queryParamsAndHeaders(queryParams);
    return await apiCall({
      url: `${backendUrl}/api/event/dashboard?${queryString}`,
      headers,
    });
  }

  async function getVolunteerDataFile(
    affiliate,
    filename,
    created,
    data_source,
    shortName
  ) {
    try {
      const { headers, queryString } = await queryParamsAndHeaders({
        affiliate,
        filename,
        created,
        data_source,
      });

      const url = `${backendUrl}/api/download?${queryString}`;

      const response = await fetch(url, { method: "GET", headers });

      if (response.error) {
        return { error: true };
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute(
        "download",
        shortName + "-de-enhanced" + "\u{1F308}" + ".csv" || "data.csv"
      );
      document.body.appendChild(link);
      link.click();

      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(downloadUrl);
      return { error: false };
    } catch (error) {
      console.error("Error downloading file:", error);
      return { error: true };
    }
  }

  return {
    getDashboard,
    getVolunteerDataFile,
  };
}
